<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-download`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 36a1 1 0 011 1v3h28v-3a1 1 0 011-1h2a1 1 0 011 1v5a2 2 0 01-2 2H8a2 2 0 01-2-2v-5a1 1 0 011-1h2zM23 5h2a1 1 0 01.993.883L26 6v22.071l6.02-6.02a1 1 0 011.32-.084l.095.084 1.414 1.414a1 1 0 01.084 1.32l-.084.094-9.9 9.9a1 1 0 01-1.32.083l-.093-.084-9.9-9.9a1 1 0 01-.083-1.32l.083-.093 1.414-1.415a1 1 0 011.32-.083l.095.084 5.534 5.535L22 6a1 1 0 01.883-.993L23 5h2-2z"/></svg>
</template>
<script>

export default {
  name: 'IconDownload',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
